/* eslint-disable no-unused-vars */

import React, { useContext, useEffect, useReducer, useState } from "react";
import { toast } from "react-toastify";

import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";
import PauseCircleOutlineIcon from "@material-ui/icons/PauseCircleOutline";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import StopIcon from "@material-ui/icons/Stop";
import RepeatIcon from "@material-ui/icons/Repeat";
import EventIcon from "@material-ui/icons/Event";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";
import { isArray } from "lodash";
import CampaignModal from "../../components/CampaignModal";
import CampaignExecutionsModal from "../../components/CampaignExecutionsModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import AttachmentPreview from "../../components/AttachmentPreview";
import WhatsAppPolicyWarning from "../../components/WhatsAppPolicyWarning";
import CampaignsBrowseBar from "../../components/CampaignsBrowseBar";
import CampaignCard from "../../components/CampaignCard";
import { SocketContext } from "../../context/Socket/SocketContext";
import toastError from "../../errors/toastError";
import { useDate } from "../../hooks/useDate";
import { useTimezone } from "../../hooks/useTimezone";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import moment from "moment";

const reducer = (state, action) => {
  if (action.type === "LOAD_CAMPAIGNS") {
    const campaigns = action.payload;

    // ✅ REEMPLAZAR completamente las campañas (no agregar)
    // Esto asegura que cuando cambia la página o búsqueda, se muestren los datos correctos
    if (isArray(campaigns)) {
      return campaigns;
    }

    return [];
  }

  if (action.type === "UPDATE_CAMPAIGNS") {
    const campaign = action.payload;

    // ✅ CORRECCIÓN DE RAÍZ: Validar que el payload existe y tiene id antes de procesar
    if (!campaign || !campaign.id) {
      console.warn("[Campaigns] UPDATE_CAMPAIGNS: Payload inválido recibido:", campaign);
      return state; // Retornar estado actual sin cambios si el payload es inválido
    }

    const campaignIndex = state.findIndex((u) => u && u.id === campaign.id);

    if (campaignIndex !== -1) {
      // ✅ Crear nueva referencia del array para forzar re-render
      const updatedState = [...state];
      updatedState[campaignIndex] = { ...campaign }; // Spread para nueva referencia
      return updatedState;
    } else {
      // ✅ Agregar nueva campaña al inicio
      return [{ ...campaign }, ...state];
    }
  }

  if (action.type === "DELETE_CAMPAIGN") {
    const campaignId = action.payload;

    const campaignIndex = state.findIndex((u) => u.id === campaignId);
    if (campaignIndex !== -1) {
      state.splice(campaignIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema - AMPLIADO para mejor UX
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "auto",
    overflowX: "auto", // ✅ Permitir scroll horizontal si es necesario
    minWidth: "100%", // ✅ Asegurar ancho mínimo completo
    width: "100%", // ✅ Ancho completo del contenedor
    ...theme.scrollbarStyles,
    borderRadius: "12px",
    boxShadow: theme.mode === "dark" ? "0 4px 20px rgba(0,0,0,0.3)" : "0 4px 20px rgba(0,0,0,0.1)",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === "dark" ? "#4B5563" : "#e0e0e0"}`,
  },

  // ✅ CORREGIDO: TableHeader dinámico según tema - AMPLIADO
  tableHeader: {
    backgroundColor: theme.mode === "dark" ? "#1f2937" : "#f8fafc",
    color: theme.mode === "dark" ? "#e5e7eb" : "#334155",
    fontWeight: 700,
    fontSize: "0.78rem",
    padding: theme.spacing(1.5),
    whiteSpace: "nowrap",
    minWidth: "120px",
  },

  // ✅ CORREGIDO: TableRow dinámico según tema - AMPLIADO
  tableRow: {
    backgroundColor: theme.palette.background.paper,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "#374151" : theme.palette.action.hover,
    },
    "& td": {
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.mode === "dark" ? "#4B5563" : "rgba(224, 224, 224, 0.5)"}`,
      whiteSpace: "nowrap", // ✅ Evitar que el texto se corte
      padding: theme.spacing(1.5), // ✅ Padding adecuado para mejor legibilidad
    },
  },

  // ✅ ESTILOS DE BOTONES MEJORADOS
  primaryButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontWeight: 700,
    textTransform: "none",
    padding: theme.spacing(1, 2),
    borderRadius: 999,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  // ✅ ESTILOS DE ICONOS MEJORADOS
  actionIcon: {
    color: "#1976d2",
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.1)",
    },
  },

  deleteIcon: {
    color: "#d32f2f",
    "&:hover": {
      backgroundColor: "rgba(211, 47, 47, 0.1)",
    },
  },

  pauseIcon: {
    color: "#ff9800",
    "&:hover": {
      backgroundColor: "rgba(255, 152, 0, 0.1)",
    },
  },

  playIcon: {
    color: "#4caf50",
    "&:hover": {
      backgroundColor: "rgba(76, 175, 80, 0.1)",
    },
  },

  stopIcon: {
    color: "#d32f2f",
    "&:hover": {
      backgroundColor: "rgba(211, 47, 47, 0.1)",
    },
  },

  // ✅ CORREGIDO: SearchField dinámico según tema
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: theme.mode === "dark" ? "#374151" : "#f5f5f5",
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === "dark" ? "#4B5563" : "#eeeeee",
      },
      "&.Mui-focused": {
        backgroundColor: theme.mode === "dark" ? "#374151" : "white",
        boxShadow: `0 0 0 2px ${theme.mode === "dark" ? "rgba(59, 130, 246, 0.3)" : "rgba(25, 118, 210, 0.2)"}`,
      },
      "& fieldset": {
        borderColor: theme.mode === "dark" ? "#4B5563" : "#e0e0e0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },

  gridWrap: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: 16,
    padding: theme.spacing(1),
  },
  statusChip: {
    fontWeight: "bold",
    borderRadius: 16,
    padding: theme.spacing(0.5, 1),
  },

  statusInactive: {
    backgroundColor: "#9e9e9e",
    color: "white",
  },

  statusScheduled: {
    backgroundColor: "#2196f3",
    color: "white",
  },

  statusInProgress: {
    backgroundColor: "#ff9800",
    color: "white",
  },

  statusCancelled: {
    backgroundColor: "#f44336",
    color: "white",
  },

  statusFinished: {
    backgroundColor: "#4caf50",
    color: "white",
  },
}));

const Campaigns = () => {
  const classes = useStyles();
  const theme = useTheme();

  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  // ✅ Estados para paginación frontend
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(13); // ✅ Aumentado a 20 para mostrar más campañas
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [deletingCampaign, setDeletingCampaign] = useState(null);
  const [campaignModalOpen, setCampaignModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [pauseModalOpen, setPauseModalOpen] = useState(false);
  const [stopModalOpen, setStopModalOpen] = useState(false);
  const [campaignToPause, setCampaignToPause] = useState(null);
  const [campaignToStop, setCampaignToStop] = useState(null);
  const [searchParam, setSearchParam] = useState("");
  const [campaigns, dispatch] = useReducer(reducer, []);
  const [executionsModalOpen, setExecutionsModalOpen] = useState(false);
  const [selectedCampaignForExecutions, setSelectedCampaignForExecutions] = useState(null);
  const [selectedCampaignType, setSelectedCampaignType] = useState(null); // 'UNICA' o 'RECURRENTE'
  const [addMenuAnchorEl, setAddMenuAnchorEl] = useState(null);
  const [viewMode, setViewMode] = useState("grid");
  const [typeFilter, setTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const { datetimeToClient } = useDate();
  const { formatDateTime } = useTimezone();

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
    // ✅ Resetear paginación frontend al cambiar búsqueda
    setPage(0);
  }, [searchParam]);

  // ✅ ELIMINADO: Ya no necesitamos resetear cuando cambia pageNumber porque cargamos todo de una vez
  // useEffect(() => { dispatch({ type: "RESET" }); }, [pageNumber]);

  // ✅ Resetear paginación frontend cuando se cargan nuevas campañas (sin búsqueda)
  useEffect(() => {
    if (campaigns.length > 0 && pageNumber === 1 && !searchParam) {
      setPage(0);
    }
  }, [campaigns.length, pageNumber, searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchCampaigns();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam]); // ✅ Eliminado pageNumber porque siempre cargamos todo de una vez

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    socket.on(`company-${companyId}-campaign`, (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CAMPAIGNS", payload: data.record });
      }
      if (data.action === "delete") {
        dispatch({ type: "DELETE_CAMPAIGN", payload: +data.id });
      }
    });
    return () => {
      socket.disconnect();
    };
  }, [socketManager]);

  const fetchCampaigns = async () => {
    try {
      // ✅ Cargar TODAS las campañas de una vez (pageNumber = 1 con limit grande en backend)
      const { data } = await api.get("/campaigns/", {
        params: { searchParam, pageNumber: 1 }, // Siempre página 1, el backend devuelve todas con limit=1000
      });
      dispatch({ type: "LOAD_CAMPAIGNS", payload: data.records });
      setHasMore(false); // Ya no hay más porque cargamos todo
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenCampaignModal = (campaignType = "UNICA") => {
    setSelectedCampaign(null);
    setSelectedCampaignType(campaignType);
    setCampaignModalOpen(true);
  };

  // ✅ Nueva función para manejar el dropdown del botón principal
  const handleOpenAddMenu = (event) => {
    event.stopPropagation();
    setAddMenuAnchorEl(event.currentTarget);
  };

  const handleCloseAddMenu = () => {
    setAddMenuAnchorEl(null);
  };

  const handleCloseCampaignModal = () => {
    setSelectedCampaign(null);
    setCampaignModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  // ✅ Función para validar si una campaña es editable según las reglas de negocio
  const isCampaignEditable = (campaign) => {
    const now = moment();

    // REGLA 1: INATIVA siempre editable
    if (campaign.status === "INATIVA") {
      return true;
    }

    // REGLA 2: EM_ANDAMENTO nunca editable
    if (campaign.status === "EM_ANDAMENTO") {
      return false;
    }

    // REGLA 2.1: FINALIZADA - ÚNICAS permiten ver en solo lectura
    if (campaign.status === "FINALIZADA") {
      return false;
    }

    // REGLA 3: CANCELADA siempre editable
    if (campaign.status === "CANCELADA") {
      return true;
    }

    // REGLA 4: PROGRAMADA - Validar tiempo mínimo (10 minutos)
    if (campaign.status === "PROGRAMADA") {
      // Para campañas recurrentes activas, validar nextScheduledAt
      const timeToCheck =
        campaign.isRecurring && campaign.executionCount > 0 && campaign.nextScheduledAt
          ? moment(campaign.nextScheduledAt)
          : moment(campaign.scheduledAt);

      if (!timeToCheck.isValid()) {
        return false;
      }

      const minutesUntilExecution = timeToCheck.diff(now, "minutes");
      return minutesUntilExecution > 10;
    }

    // Por defecto, no editable
    return false;
  };

  // ✅ Función para validar si se puede abrir el modal (editable o solo lectura)
  const canOpenCampaignModal = (campaign) => {
    if (isCampaignEditable(campaign)) {
      return true;
    }

    // Permitir abrir modal en solo lectura para campañas ÚNICAS finalizadas
    if (campaign.status === "FINALIZADA" && !campaign.isRecurring) {
      return true;
    }

    return false;
  };

  const openCampaignReport = (campaign) => {
    setSelectedCampaignForExecutions(campaign);
    setExecutionsModalOpen(true);
  };

  const filteredCampaigns = campaigns.filter((campaign) => {
    if (!campaign) return false;
    const isRecurring = campaign.tipo === "RECURRENTE" || campaign.isRecurring === true || campaign.isRecurring === 1;
    if (typeFilter === "unica" && isRecurring) return false;
    if (typeFilter === "recurrente" && !isRecurring) return false;
    if (statusFilter && campaign.status !== statusFilter) return false;
    return true;
  });

  const handleEditCampaign = (campaign) => {
    // ✅ Validar si se puede abrir el modal (editable o solo lectura)
    if (!canOpenCampaignModal(campaign)) {
      let errorMessage = "";

      if (campaign.status === "EM_ANDAMENTO") {
        errorMessage =
          "No se puede editar una campaña en proceso. Debe pausarla o pararla primero.";
      } else if (campaign.status === "FINALIZADA" && campaign.isRecurring) {
        errorMessage = "No se puede editar una campaña recurrente finalizada.";
      } else if (campaign.status === "PROGRAMADA") {
        const timeToCheck =
          campaign.isRecurring && campaign.executionCount > 0 && campaign.nextScheduledAt
            ? moment(campaign.nextScheduledAt)
            : moment(campaign.scheduledAt);

        if (timeToCheck.isValid()) {
          const minutesUntilExecution = timeToCheck.diff(moment(), "minutes");
          if (minutesUntilExecution <= 10) {
            errorMessage =
              "No se puede editar una campaña con menos de 10 minutos para su ejecución.";
          }
        } else {
          errorMessage = "No se puede editar esta campaña. Fecha de ejecución inválida.";
        }
      } else {
        errorMessage = "No se puede editar esta campaña en su estado actual.";
      }

      if (errorMessage) {
        toast.error(errorMessage);
        return;
      }
    }

    // Abrir el modal (editable o solo lectura)
    setSelectedCampaign(campaign);
    setCampaignModalOpen(true);
  };

  const handleDeleteCampaign = async (campaignId) => {
    try {
      await api.delete(`/campaigns/${campaignId}`);
      toast.success(i18n.t("campaigns.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingCampaign(null);
    setSearchParam("");
    setPageNumber(1);
  };

  // ✅ ELIMINADO: Infinite scroll ya no es necesario porque cargamos todas las campañas de una vez
  // const loadMore = () => { ... }
  // const handleScroll = (e) => { ... }

  const formatStatus = (val) => {
    switch (val) {
      case "INATIVA":
        return (
          <Chip
            icon={<PauseCircleOutlineIcon />}
            label={i18n.t("campaigns.report.statusValues.inactive")}
            className={`${classes.statusChip} ${classes.statusInactive}`}
            size="small"
          />
        );
      case "PROGRAMADA":
        return (
          <Chip
            icon={<EventIcon />}
            label={i18n.t("campaigns.report.statusValues.scheduled")}
            className={`${classes.statusChip} ${classes.statusScheduled}`}
            size="small"
          />
        );
      case "EM_ANDAMENTO":
        return (
          <Chip
            icon={<PlayCircleOutlineIcon />}
            label={i18n.t("campaigns.report.statusValues.inProgress")}
            className={`${classes.statusChip} ${classes.statusInProgress}`}
            size="small"
          />
        );
      case "CANCELADA":
        return (
          <Chip
            icon={<CancelIcon />}
            label={i18n.t("campaigns.report.statusValues.cancelled")}
            className={`${classes.statusChip} ${classes.statusCancelled}`}
            size="small"
          />
        );
      case "FINALIZADA":
        return (
          <Chip
            icon={<CheckCircleIcon />}
            label={i18n.t("campaigns.report.statusValues.finished")}
            className={`${classes.statusChip} ${classes.statusFinished}`}
            size="small"
          />
        );
      default:
        return val;
    }
  };

  const handlePauseCampaign = (campaign) => {
    setCampaignToPause(campaign);
    setPauseModalOpen(true);
  };

  const confirmPauseCampaign = async () => {
    if (!campaignToPause) return;

    try {
      await api.post(`/campaigns/${campaignToPause.id}/cancel`);
      toast.success(i18n.t("campaigns.toasts.cancel"));
      setPageNumber(1);
      fetchCampaigns();
      setPauseModalOpen(false);
      setCampaignToPause(null);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleStopCampaign = (campaign) => {
    setCampaignToStop(campaign);
    setStopModalOpen(true);
  };

  const confirmStopCampaign = async () => {
    if (!campaignToStop) return;

    try {
      await api.post(`/campaigns/${campaignToStop.id}/stop`);
      toast.success("Campaña parada definitivamente");
      setPageNumber(1);
      fetchCampaigns();
      setStopModalOpen(false);
      setCampaignToStop(null);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const restartCampaign = async (campaign) => {
    try {
      await api.post(`/campaigns/${campaign.id}/restart`);
      toast.success(i18n.t("campaigns.toasts.restart"));
      setPageNumber(1);
      fetchCampaigns();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <MainContainer mobileScroll>
      <WhatsAppPolicyWarning storageKey="campaigns" />
      <ConfirmationModal
        title={
          deletingCampaign &&
          `${i18n.t("campaigns.confirmationModal.deleteTitle")} ${deletingCampaign.name}?`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteCampaign(deletingCampaign.id)}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>

      {/* Modal de confirmación para Pausar */}
      <Dialog
        open={pauseModalOpen}
        onClose={() => {
          setPauseModalOpen(false);
          setCampaignToPause(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Pausar Campaña</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1">
            ¿Está seguro de pausar esta campaña? Los mensajes ya enviados no se revierten. Podrá
            reanudarla después.
          </Typography>
          {campaignToPause && (
            <Typography variant="body2" style={{ marginTop: 16, fontWeight: "bold" }}>
              Campaña: {campaignToPause.name}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPauseModalOpen(false);
              setCampaignToPause(null);
            }}
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button onClick={confirmPauseCampaign} color="primary" variant="contained">
            Pausar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de confirmación para Parar */}
      <Dialog
        open={stopModalOpen}
        onClose={() => {
          setStopModalOpen(false);
          setCampaignToStop(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ color: "#d32f2f" }}>
          <Box display="flex" alignItems="center">
            <WarningIcon style={{ marginRight: 8 }} />
            Parar Campaña Definitivamente
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            variant="body1"
            style={{ fontWeight: "bold", color: "#d32f2f", marginBottom: 16 }}
          >
            ACCIÓN IRREVERSIBLE: ¿Está seguro de PARAR DEFINITIVAMENTE esta campaña?
          </Typography>
          <Typography variant="body2">
            Esta acción NO se puede deshacer. Los mensajes ya enviados se mantendrán, pero NO podrá
            reanudar la campaña.
          </Typography>
          {campaignToStop && (
            <Typography variant="body2" style={{ marginTop: 16, fontWeight: "bold" }}>
              Campaña: {campaignToStop.name}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setStopModalOpen(false);
              setCampaignToStop(null);
            }}
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={confirmStopCampaign}
            color="secondary"
            variant="contained"
            style={{ backgroundColor: "#d32f2f" }}
          >
            Parar Definitivamente
          </Button>
        </DialogActions>
      </Dialog>

      <CampaignModal
        resetPagination={() => {
          setPageNumber(1);
          fetchCampaigns();
        }}
        open={campaignModalOpen}
        onClose={handleCloseCampaignModal}
        aria-labelledby="form-dialog-title"
        campaignId={selectedCampaign && selectedCampaign.id}
        campaignType={
          selectedCampaignType || (selectedCampaign && selectedCampaign.tipo) || "UNICA"
        }
      />
      <MainHeader>
        <Title subtitle="Envía mensajes masivos a contactos de WhatsApp o Telegram y sigue el progreso de cada campaña.">
          {i18n.t("campaigns.title")}
        </Title>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <CampaignsBrowseBar
          searchValue={searchParam}
          onSearch={handleSearch}
          searchPlaceholder={i18n.t("campaigns.searchPlaceholder") || "Buscar"}
          typeValue={typeFilter}
          onTypeChange={(value) => {
            setTypeFilter(value);
            setPage(0);
          }}
          typeOptions={[
            { value: "", label: "Tipo" },
            { value: "unica", label: "Única" },
            { value: "recurrente", label: "Recurrente" },
          ]}
          statusValue={statusFilter}
          onStatusChange={(value) => {
            setStatusFilter(value);
            setPage(0);
          }}
          statusOptions={[
            { value: "", label: "Estado" },
            { value: "PROGRAMADA", label: "Programada" },
            { value: "EM_ANDAMENTO", label: "En proceso" },
            { value: "FINALIZADA", label: "Terminada" },
            { value: "CANCELADA", label: "Cancelada" },
            { value: "INATIVA", label: "Inactiva" },
          ]}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          actions={
                <Box
                  position="relative"
                  display="inline-flex"
                  style={{
                    zIndex: 1300,
                    position: "relative",
                  }}
                >
                  <ButtonGroup
                    variant="contained"
                    color="primary"
                    style={{
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
                      overflow: "visible",
                      position: "relative",
                      zIndex: 1,
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => handleOpenCampaignModal("UNICA")}
                      className={classes.primaryButton}
                      startIcon={<AddIcon />}
                      style={{
                        textTransform: "none",
                        fontWeight: 700,
                        fontSize: "14px",
                        padding: "8px 18px",
                        flex: 1,
                      }}
                    >
                      {i18n.t("campaigns.buttons.add")}
                    </Button>
                    <Button
                      size="small"
                      onClick={handleOpenAddMenu}
                      style={{
                        minWidth: "36px",
                        padding: "0 8px",
                        borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                    >
                      <ArrowDropDownIcon />
                    </Button>
                  </ButtonGroup>
                  <Menu
                    anchorEl={addMenuAnchorEl}
                    open={Boolean(addMenuAnchorEl)}
                    onClose={handleCloseAddMenu}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    style={{
                      zIndex: 1301,
                    }}
                    PaperProps={{
                      style: {
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                        minWidth: "250px",
                        marginTop: "4px",
                        zIndex: 1301,
                      },
                    }}
                    MenuListProps={{
                      style: {
                        padding: "4px 0",
                      },
                    }}
                    getContentAnchorEl={null}
                  >
                    <MenuItem
                      onClick={() => {
                        handleOpenCampaignModal("UNICA");
                        handleCloseAddMenu();
                      }}
                      style={{
                        padding: "12px 20px",
                        fontSize: "14px",
                      }}
                    >
                      <Box display="flex" alignItems="center" width="100%">
                        <PhoneAndroidIcon style={{ marginRight: 12, fontSize: 20 }} />
                        Campaña ÚNICA
                      </Box>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleOpenCampaignModal("RECURRENTE");
                        handleCloseAddMenu();
                      }}
                      style={{
                        padding: "12px 20px",
                        fontSize: "14px",
                      }}
                    >
                      <Box display="flex" alignItems="center" width="100%">
                        <RepeatIcon style={{ marginRight: 12, fontSize: 20 }} />
                        Campaña RECURRENTE
                      </Box>
                    </MenuItem>
                  </Menu>
                </Box>
          }
        />

        {viewMode === "grid" ? (
          <Box className={classes.gridWrap}>
            {loading ? (
              <Typography variant="body2" color="textSecondary">Cargando campañas...</Typography>
            ) : filteredCampaigns.length === 0 ? (
              <Typography variant="body2" color="textSecondary">No se encontraron campañas</Typography>
            ) : (
              filteredCampaigns.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((campaign) => (
                <CampaignCard
                  key={campaign.id}
                  name={campaign.name}
                  dateLabel={campaign.scheduledAt ? formatDateTime(campaign.scheduledAt) : ""}
                  connectionName={campaign.whatsapp?.name}
                  countLabel={`${campaign.deliveredCount || 0} / ${campaign.totalContacts || 0}`}
                  statusChip={formatStatus(campaign.status)}
                  onOpen={() => openCampaignReport(campaign)}
                  actions={
                    <>
                      <IconButton
                        size="small"
                        onClick={() => handleEditCampaign(campaign)}
                        className={classes.actionIcon}
                        disabled={!canOpenCampaignModal(campaign)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setConfirmModalOpen(true);
                          setDeletingCampaign(campaign);
                        }}
                        className={classes.deleteIcon}
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </>
                  }
                />
              ))
            )}
          </Box>
        ) : (
        <Table size="small" style={{ minWidth: "1520px" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.name")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                Adjunto
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.status")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                Tipo
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                Ejecuciones
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                Próxima Ejecución
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.contactList")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.whatsapp")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.aiAgent")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.scheduledAt")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.completedAt")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("campaigns.table.actions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(() => {
              // ✅ Calcular campañas paginadas
              const paginatedCampaigns = filteredCampaigns.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              );

              return paginatedCampaigns.map((campaign) => (
                <TableRow
                  key={campaign.id}
                  className={classes.tableRow}
                  onClick={() => openCampaignReport(campaign)}
                >
                  <TableCell align="center">{campaign.name}</TableCell>
                  <TableCell align="center">
                    {campaign.mediaPath || campaign.mediaName ? (
                      <AttachmentPreview
                        mediaPath={campaign.mediaPath}
                        mediaName={campaign.mediaName}
                        size="compact"
                        showInfo={false}
                      />
                    ) : campaign.fileListId ? (
                      "Lista"
                    ) : (
                      "—"
                    )}
                  </TableCell>
                  <TableCell align="center">{formatStatus(campaign.status)}</TableCell>
                  <TableCell align="center">
                    {/* ✅ Usar campo 'tipo' del SP si está disponible, sino usar isRecurring */}
                    {campaign.tipo === "RECURRENTE" || campaign.isRecurring ? (
                      <Chip
                        icon={<RepeatIcon />}
                        label="Recurrente"
                        color="primary"
                        size="small"
                        style={{ fontWeight: "bold" }}
                      />
                    ) : (
                      <Chip label="Única" color="default" size="small" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {/* ✅ MEJORA UX: Mostrar contador X/Y para todas las campañas (únicas y recurrentes) */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {/* Contador X/Y - Siempre visible si hay datos, o mostrar 0/0 si no hay */}
                      {(() => {
                        // ✅ Para campañas RECURRENTES: Usar información de currentExecution si está disponible
                        let deliveredCount = campaign.deliveredCount;
                        let totalContacts = campaign.totalContacts;

                        if (campaign.isRecurring && campaign.currentExecution) {
                          // Usar progreso de la ejecución actual
                          deliveredCount = campaign.currentExecution.enviados || 0;
                          totalContacts = campaign.totalContacts || 0; // Total de contactos sigue siendo el mismo
                        }

                        return totalContacts !== undefined && deliveredCount !== undefined ? (
                          <Chip
                            label={`${deliveredCount}/${totalContacts}`}
                            size="small"
                            onClick={() => {
                              setSelectedCampaignForExecutions(campaign);
                              setExecutionsModalOpen(true);
                            }}
                            style={{
                              backgroundColor:
                                deliveredCount === totalContacts && totalContacts > 0
                                  ? "#4caf50"
                                  : deliveredCount > 0
                                    ? "#ff9800"
                                    : "#e3f2fd",
                              color:
                                deliveredCount === totalContacts && totalContacts > 0
                                  ? "white"
                                  : deliveredCount > 0
                                    ? "white"
                                    : "#1976d2",
                              fontWeight: "bold",
                              minWidth: "50px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <Chip
                            label="0/0"
                            size="small"
                            onClick={() => {
                              setSelectedCampaignForExecutions(campaign);
                              setExecutionsModalOpen(true);
                            }}
                            style={{
                              backgroundColor: "#e3f2fd",
                              color: "#1976d2",
                              fontWeight: "bold",
                              minWidth: "50px",
                              cursor: "pointer",
                            }}
                          />
                        );
                      })()}
                      {/* Para campañas recurrentes: mostrar número de ejecuciones debajo del contador */}
                      {/* ✅ SOLO mostrar para campañas RECURRENTES con executionCount > 0 */}
                      {/* ⚠️ IMPORTANTE: NO mostrar executionCount para campañas ÚNICAS (isRecurring = 0 o false) */}
                      {(campaign.tipo === "RECURRENTE" ||
                        campaign.isRecurring === true ||
                        campaign.isRecurring === 1) &&
                        campaign.executionCount !== undefined &&
                        campaign.executionCount !== null &&
                        campaign.executionCount > 0 && (
                          <span style={{ fontSize: "0.75rem", color: "#9e9e9e" }}>
                            {campaign.executionCount}{" "}
                            {campaign.executionCount === 1 ? "ejecución" : "ejecuciones"}
                          </span>
                        )}
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    {campaign.isRecurring && campaign.nextScheduledAt ? (
                      <span style={{ color: "#1976d2", fontWeight: "bold" }}>
                        {formatDateTime(campaign.nextScheduledAt)}
                      </span>
                    ) : (
                      <span style={{ color: "#9e9e9e" }}>-</span>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {campaign.contactListId && campaign.contactList
                      ? campaign.contactList.name && campaign.contactList.name.length > 30
                        ? `${campaign.contactList.name.substring(0, 30)}...`
                        : campaign.contactList.name || i18n.t("campaigns.placeholders.notDefined")
                      : i18n.t("campaigns.placeholders.notDefined")}
                  </TableCell>
                  <TableCell align="center">
                    {campaign.whatsappId && campaign.whatsapp
                      ? campaign.whatsapp.name || i18n.t("campaigns.placeholders.notDefinedMale")
                      : i18n.t("campaigns.placeholders.notDefinedMale")}
                  </TableCell>
                  <TableCell align="center">
                    {campaign.prompt && campaign.prompt.name ? campaign.prompt.name : "—"}
                  </TableCell>
                  <TableCell align="center">
                    {campaign.scheduledAt
                      ? formatDateTime(campaign.scheduledAt)
                      : i18n.t("campaigns.placeholders.noScheduling")}
                  </TableCell>
                  <TableCell align="center">
                    {campaign.completedAt
                      ? formatDateTime(campaign.completedAt)
                      : i18n.t("campaigns.placeholders.notCompleted")}
                  </TableCell>
                  {/* <TableCell align="center">
                    {campaign.confirmation ? "Habilitada" : "Desabilitada"}
                  </TableCell> */}
                  <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                      <IconButton
                        onClick={() => handlePauseCampaign(campaign)}
                        title="Pausar Campaña"
                        size="small"
                        className={classes.pauseIcon}
                      >
                        <PauseCircleOutlineIcon />
                      </IconButton>
                    )}
                    {(campaign.status === "PROGRAMADA" || campaign.status === "EM_ANDAMENTO") && (
                      <IconButton
                        onClick={() => handleStopCampaign(campaign)}
                        title="Parar Campaña Definitivamente"
                        size="small"
                        className={classes.stopIcon}
                      >
                        <StopIcon />
                      </IconButton>
                    )}
                    {campaign.status === "CANCELADA" && (
                      <IconButton
                        onClick={() => restartCampaign(campaign)}
                        title="Reanudar Campaña"
                        size="small"
                        className={classes.playIcon}
                      >
                        <PlayCircleOutlineIcon />
                      </IconButton>
                    )}
                    {/* ✅ MEJORA UX: Botón REPORTE removido - La información está visible en la columna "Ejecuciones" */}
                    <IconButton
                      size="small"
                      onClick={() => handleEditCampaign(campaign)}
                      className={classes.actionIcon}
                      title={
                        isCampaignEditable(campaign)
                          ? "Editar Campaña"
                          : campaign.status === "FINALIZADA" && !campaign.isRecurring
                            ? "Ver Campaña (Solo Lectura)"
                            : "No se puede editar esta campaña"
                      }
                      disabled={!canOpenCampaignModal(campaign)}
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      size="small"
                      onClick={(e) => {
                        setConfirmModalOpen(true);
                        setDeletingCampaign(campaign);
                      }}
                      className={classes.deleteIcon}
                      title="Eliminar Campaña"
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ));
            })()}
            {loading && <TableRowSkeleton columns={12} />}
          </TableBody>
        </Table>
        )}

        {/* ✅ PAGINACIÓN: Solo aparece cuando hay resultados */}
        {!loading && filteredCampaigns.length > 0 && (
          <TablePagination
            component="div"
            count={filteredCampaigns.length}
            page={page}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 13, 20, 50, 100]}
            labelRowsPerPage="Registros por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            style={{
              backgroundColor: "transparent",
              color: "inherit",
            }}
          />
        )}
      </Paper>

      {/* Modal de Ejecuciones */}
      {selectedCampaignForExecutions && (
        <CampaignExecutionsModal
          open={executionsModalOpen}
          onClose={() => {
            setExecutionsModalOpen(false);
            setSelectedCampaignForExecutions(null);
          }}
          campaignId={selectedCampaignForExecutions.id}
          campaignName={selectedCampaignForExecutions.name}
        />
      )}
    </MainContainer>
  );
};

export default Campaigns;
